export namespace UNIT_GROUP_TYPES {
    export const UNIT = "unit"
    export const TIME = "time"
}

export type UNIT_GROUP_TYPES = typeof UNIT_GROUP_TYPES[keyof typeof UNIT_GROUP_TYPES]


// WEBPACK FOOTER //
// ./src/state/pricing/UnitGroupTypes.ts